import { useState } from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import TokenTable from './components/TokenTable'
import SubmitModal from './components/SubmitModal'

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSubmitted = () => {
    setRefreshKey((k) => k + 1);
  };

  return (
    <>
      <Navbar onOpenModal={() => setIsModalOpen(true)} />
      <main>
        <Hero onOpenModal={() => setIsModalOpen(true)} />
        <TokenTable refreshKey={refreshKey} />
      </main>
      <SubmitModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmitted={handleSubmitted}
      />
    </>
  )
}

export default App
